
import React from 'react';
import { Mic, MicOff, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useVoiceCommands } from '@/contexts/VoiceCommandContext';
import { motion, AnimatePresence } from 'framer-motion';

interface VoiceCommandButtonProps {
  className?: string;
  variant?: 'default' | 'minimal';
}

const VoiceCommandButton: React.FC<VoiceCommandButtonProps> = ({ 
  className,
  variant = 'default'
}) => {
  const { state, toggleListening } = useVoiceCommands();
  const { isListening, recognizedText } = state;
  
  return (
    <div className={`relative ${className}`}>
      {variant === 'default' && (
        <AnimatePresence>
          {isListening && (
            <motion.div 
              initial={{ opacity: 0, width: 0 }}
              animate={{ opacity: 1, width: 'auto' }}
              exit={{ opacity: 0, width: 0 }}
              className="absolute right-full mr-2 bg-black/80 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm"
            >
              {recognizedText || "Listening..."}
            </motion.div>
          )}
        </AnimatePresence>
      )}
      
      <Button
        size={variant === 'minimal' ? 'sm' : 'default'}
        variant={isListening ? "default" : "outline"}
        className={`rounded-full ${isListening ? 'bg-primary text-primary-foreground animate-pulse' : ''}`}
        onClick={toggleListening}
      >
        {isListening ? (
          <Mic className="h-4 w-4" />
        ) : (
          <MicOff className="h-4 w-4" />
        )}
        {variant === 'default' && (
          <span className="ml-2 hidden sm:inline">
            {isListening ? 'Listening...' : 'Voice Command'}
          </span>
        )}
      </Button>
    </div>
  );
};

export default VoiceCommandButton;
